/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {useNavigate} from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import type {ChangeEvent, FormEvent} from 'react';
import {Form} from 'react-bootstrap';
import {useEffect, useState} from 'react';

import LayoutSignIn from 'components/Layouts/LayoutSignIn';
import {useGetVersionQuery, useSigninMutation} from 'services';
import packageJson from '../../../package.json';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {setUser} from 'store/userSlice';

const SignIn = () => {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user);

	const navigate = useNavigate();

	const [state, setState] = useState({
		userName: localStorage.getItem('userName') || '',
		password: '',
		isAuthenticated: false,
		errorMessage: '',
		isValid: false,
		Alertvisible: false,
		isRemember: false,
	});

	useEffect(() => {
		if (user.token) {
			navigate('/dashboard');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.token]);

	// api
	const {data: getVersion} = useGetVersionQuery();
	const [signIn, {isLoading}] = useSigninMutation();

	useEffect(() => {
		const userName = localStorage.getItem('userName');

		if (userName?.length) {
			setState(prev => ({...prev, userName, isRemember: true}));
		}
	}, []);

	const remember = (e: ChangeEvent<HTMLInputElement>) => {
		const {checked} = e.target;

		setState(prev => ({...prev, isRemember: checked}));
	};

	const queryChangeName = (e: ChangeEvent<HTMLInputElement>) => {
		setState(prev => ({
			...prev,
			Alertvisible: false,
			userName: e.target.value,
		}));
	};

	const queryChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
		setState(prev => ({
			...prev,
			Alertvisible: false,
			password: e.target.value,
		}));
	};

	/**
	 * The function `handleSignIn` is an asynchronous function that handles the sign-in process in a
	 * TypeScript React application, including storing the username in local storage, making a sign-in API
	 * call, setting the user state, rendering the appropriate page based on user roles, and displaying an
	 * error message if there is an error.
	 * @param e - The parameter `e` is of type `FormEvent<HTMLFormElement>`. It represents the event
	 * object that is triggered when the form is submitted.
	 */
	const handleSignIn = async (e: FormEvent<HTMLFormElement>) => {
		try {
			e.preventDefault();
			localStorage.setItem('userName', state.userName);

			const response = await signIn({
				username: state.userName,
				password: state.password,
			}).unwrap();

			if (response.token) {
				localStorage.setItem('Token', response.token);

				const roles = [...response.permissions];

				const tmp = {
					...response,
					tokens: response.token,
					roles,
				};

				if (!response.apiConsumer) {
					tmp.refreshToken = response.refreshToken;
				}

				dispatch(setUser(tmp));

				renderPage({roles, navigate});

				if (state.Alertvisible) {
					setTimeout(
						() => setState(prev => ({...prev, Alertvisible: false})),
						44000,
					);
				}
			}
		} catch (error: any) {
			setState(prev => ({...prev, Alertvisible: true}));
			setState(prev => ({
				...prev,
				errorMessage: error.data || 'there is an error in User ',
			}));
		}
	};

	const date = new Date();
	const year = date.getFullYear();

	return (
		<LayoutSignIn>
			<div className="total-center text-center signin">
				{/* <!-- Nested Row within Card Body --> */}

				<form onSubmit={handleSignIn} className="form-signin">
					<img
						className="mb-4"
						src="../../assets/img/logo.png"
						width={160}
						height={68}
						alt="PCRF"
					/>
					<h1 className="h4 mb-3 font-weight-normal">Please sign in</h1>
					<label htmlFor="inputUsername" className="sr-only">
						User name
					</label>
					<Form.Control
						value={state.userName}
						id="inputUser"
						className="form-control"
						placeholder="User name"
						required
						autoFocus={state.userName.length ? false : true}
						onChange={e => queryChangeName(e as never)}
					/>
					<label htmlFor="inputPassword" className="sr-only">
						Password
					</label>
					<Form.Control
						type="password"
						id="inputPassword"
						className="form-control mt-3"
						placeholder="Password"
						required
						onChange={e => queryChangePassword(e as never)}
					/>
					<div className="checkbox mb-3">
						<Form.Check
							name="isRemember"
							checked={Boolean(state.isRemember)}
							type="switch"
							label="Remember me"
							id="custom-switch"
							className="ml-4 mt-2"
							onChange={remember}
						/>
					</div>
					<button
						disabled={isLoading}
						className="btn btn-lg btn-primary btn-block"
						type="submit">
						Sign in
					</button>
					<p className="mt-5 mb-3 text-muted">
						{`GUI PCRF Version ${packageJson.version} | Core PCRF Version ${getVersion} | © Copyright Summa Networks ${year} | All rights reserved.`}
					</p>

					{state.Alertvisible && (
						<Alert variant="danger"> {state.errorMessage} </Alert>
					)}
				</form>
			</div>
		</LayoutSignIn>
	);
};

type TRenderPage = {
	roles: string[];
	navigate: any;
};
/**
 * The function `renderPage` takes in an object with roles and navigate function, and based on the
 * roles, it navigates to different pages.
 * @param {TRenderPage}  - - `roles`: an array of strings representing the roles of the user
 */
const renderPage = ({roles, navigate}: TRenderPage) => {
	roles.forEach(element => {
		switch (true) {
			case element.includes('monitoring'):
				return navigate('/dashboard');
			case element.includes('policy'):
				return navigate('/policy');
			case element.includes('system_admin'):
				return navigate('/configuration');
			case element.includes('subscriber'):
			case element.includes('plan'):
				return navigate('/subscriberProfile');
			case element.includes('admin'):
				return navigate('/users');
			default:
				return navigate('/dashboard');
		}
	});
};

export default SignIn;
